import { setAllChildren } from './node-utils';
import { EngineNodesStateModel, ObjectId, NodeState } from './engine.nodes.state.model';
import { NodeActions } from './engine.nodes.actions';

declare const immer;

export function calcShownObjectState(
  state: EngineNodesStateModel,
  action: NodeActions.UpdateNodesShown
) {
  if (state.activeChapterId === undefined || state.nodeState === undefined) {
    return;
  }

  const [nextState, patches, inversePatches] = immer.produceWithPatches(
    state,
    (draft) => {
      const nodes: Record<ObjectId, NodeState> = draft.nodeState[draft.activeChapterId];
      const objectIds = action.objectIds || Object.keys(nodes);

      if (action.patch) {
        Object.entries(action.patch).forEach(([objectId, value]) => {
          nodes[objectId].shown = value;
        });
      } else {
        objectIds.forEach((objectId) => {
          nodes[objectId].shown = action.show;
          nodes[objectId].shownSetByTween = action.setByTween;
          if (action.objectIds) {
            setAllChildren(objectId, nodes, 'shown', action.show);
            if (action.setByTween === true) {
              setAllChildren(objectId, nodes, 'shownSetByTween', action.setByTween);
            }
          }
        });
      }
    }
  );

  const finalState = immer.produce(nextState, (draft) => {
    draft.patches = patches;
    draft.patchesForChapter[draft.activeChapterId].push(...patches);
  });

  return { finalState, patches, inversePatches };
}
